import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'ShSideBarModal',
  components: {
    ShButton,
  },
  props: {
    sideBarModalVisibility: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 650,
    },
    wrapperClosable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      height: '865px',
    };
  },
  watch: {
    sideBarModalVisibility(val) {
      this.visible = val;
    },
  },
  methods: {
    closed() {
      this.visible = false;
      this.$emit('update:sideBarModalVisibility', false);
    },
  },
};
